var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToyotaInfo = function SvgToyotaInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282830",
    fillRule: "evenodd",
    d: "M8.5 16.029A7.529 7.529 0 1 0 8.5.97a7.529 7.529 0 0 0 0 15.058m0 .971a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#282830",
    d: "M7.59 4.857a.91.91 0 1 0 1.82 0 .91.91 0 0 0-1.82 0M7.59 8.025a.91.91 0 0 1 1.821 0v4.25a.91.91 0 0 1-1.821 0z"
  })));
};
export default SvgToyotaInfo;